/**
 * RESPONSIBILITY: the pastor's letter and portrait.
 *
 * The letter is a @RenderOf value, so it arrives as markup the page inserts rather than
 * markdown the page has to parse. That is why there is no parser in this bundle.
 */
import { Html } from '@framework/react';
import type { LeadershipNoteSection } from '@app/sections';
import { Picture } from '../commons/Picture';

export function PastorsNote({ c }: { c: LeadershipNoteSection }) {
  return (
    <section className="band ldr-note-band">
      <div className="wrap">
        <div className="ldr-band-head ldr-band-head--centre">
          {c.eyebrow && <span className="ldr-kicker">{c.eyebrow}</span>}
          <h2 className="ldr-h2">{c.noteHeading}</h2>
        </div>

        <div className="ldr-letter">
          {/* Decoration: an opening quotation mark, not a word anybody reads. */}
          <span className="ldr-letter__mark" aria-hidden="true">&ldquo;</span>
          <div className="ldr-letter__body">
            {c.noteHtml
              ? <Html className="md-body">{c.noteHtml}</Html>
              : c.noteEmpty && <p className="lede">{c.noteEmpty}</p>}
          </div>
          <div className="ldr-letter__portrait-wrap">
            <Picture value={c.notePortrait} alt={c.notePortrait?.alt} className="ldr-letter__portrait" />
          </div>
        </div>
      </div>
    </section>
  );
}
